module.exports = __webpack_public_path__ + "static/sequelize-96ebac0d53c0a8be8e8d46b7387e6271.png";